module.exports = __webpack_public_path__ + "static/BlackHole1-ccddca3eeabfaa5505fde4d901192be6.png";